const SgiTinyMCEEO = function () {
    return {
        alwBlk: true,
        ctlH: 0,
        ctlW: 24,
        lblW: 6,
        desId: "EP_EO_UI_SgiTinyMCE",
        isDis: false,
        isHdn: false,
        isLbl: false,
        lblAlg: "right",
        bdText: '',
        maxL: 0,
        minL: 0,
        te: "tinymce富文本",
        teAl: "left",
        vldC: "",
        inpPopTe: "请编辑",
        ctlN: "tinymce富文本",
    }
}

export { SgiTinyMCEEO };
export default SgiTinyMCEEO;


// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiCompEO/SgiTinyMCEEO.js